import { render, staticRenderFns } from "./FormImagemBannerComponent.vue?vue&type=template&id=4ebdabbd&scoped=true&"
import script from "./FormImagemBannerComponent.vue?vue&type=script&lang=js&"
export * from "./FormImagemBannerComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormImagemBannerComponent.vue?vue&type=style&index=0&id=4ebdabbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebdabbd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VForm,VIcon,VLayout})
